import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export interface AppConfigurationResponse {
  status: string;
  data: {
    id: string;
    type: string;
    emailGroups: { [key: string]: string[] };
  };
}

@Injectable()
export class ConfigurationService {
  private emailGroups: { [key: string]: string[] } = {};
  private loadingPromise: Promise<boolean> = null;
  private loaded: boolean = false;

  constructor(private http: HttpClient) {}

  public loadConfiguration(): Promise<boolean> {
    if (this.loaded) {
      return Promise.resolve(true);
    }

    if (this.loadingPromise != null) {
      return this.loadingPromise;
    }

    this.loadingPromise = new Promise((resolve) => {
      this.http.get('/api/configuration').subscribe(
        (resp: AppConfigurationResponse) => {
          if (resp && resp.status === 'OK' && resp.data && resp.data.emailGroups) {
            this.emailGroups = resp.data.emailGroups;
            this.loaded = true;
            resolve(true);
            return;
          }
          console.error('Invalid application configuration response');
          resolve(false);
        },
        (err) => {
          console.error('Failed to load application configuration', err);
          resolve(false);
        }
      );
    });

    return this.loadingPromise;
  }

  public hasGroup(key: string): boolean {
    return !!(key && this.emailGroups && Array.isArray(this.emailGroups[key]));
  }

  public getEmailGroup(key: string): string[] {
    if (!this.hasGroup(key)) {
      return [];
    }
    return this.emailGroups[key].slice();
  }

  public getSingleEmail(key: string): string {
    const values = this.getEmailGroup(key);
    if (values.length > 0) {
      return values[0];
    }
    return '';
  }
}